import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Notification Request',
  path: '/homenet/notificationrequest',
  redirect: '/homenet/notificationrequest/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/NotificationRequestList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/notificationRequest.js